import { Component, output, signal } from '@angular/core';
import { Const } from 'src/definitions/global.definition';
import { LayoutAuthComponent } from 'src/components/layout/layout-auth.component';
import { CommonModule } from '@angular/common';
import { _StepEmailComponent } from './components/step-email.component';
import { _StepOtpComponent } from './components/step-otp.component';
import { _StepPinComponent } from './components/step-pin.component';
import { _StepCompletionComponent } from './components/step-completion.component';

@Component({
  selector: 'app-forgot-pin',
  templateUrl: './forgot-pin.page.html',
  standalone: true,
  imports: [
    CommonModule,
    LayoutAuthComponent,
    _StepEmailComponent,
    _StepOtpComponent,
    _StepPinComponent,
    _StepCompletionComponent,
  ],
})
export class ForgotPinPage {
  step: Const<typeof Step> = Step.EMAIL;

  email = signal<string>('');
  token = signal<string>('');

  back = output<void>();

  Step = Step;

  constructor() {}

  onBack() {
    this.back.emit();
  }

  onToStepOtp(email: string) {
    this.email.set(email);
    this.step = Step.OTP;
  }

  onToStepPassword(token: string) {
    this.token.set(token);
    this.step = Step.PASSWORD;
  }

  onToStepCompletion() {
    this.step = Step.COMPLETION;
  }
}

const Step = {
  EMAIL: 'EMAIL',
  OTP: 'OTP',
  PASSWORD: ' PASSWORD',
  COMPLETION: 'COMPLETION',
} as const;
